import(/* webpackMode: "eager" */ "/home/runner/_work/platform/platform/packages/dashboard/src/app/not-found.tsx");
